import { FieldBase } from '@shared/components/dynamic-form/models/field-base';

export class FieldNumber extends FieldBase<number> {
  override controlType = 'number';
}
